import React, { useState } from "react"
import Checkbox from "../../gui/Button/Checkbox"
import { UpdateEvent } from "../../gui/GUIEvents"
import Dot3Icon from "../../gui/Icons/Dot3Icon"
import { MenuRow, TMenuItemRenderer, TMenuRow } from "../../gui/Menu/Menu"
import MenuButton from "../../gui/Menu/MenuButton"
import { usePath } from "../../libs/path/PathProvider"
import PortAccount from "../../models/PortAccount"
import PortUtils from "../../portlibs/PortUtils"
import AccountFilter from "./AccountFilter"
import SearchFilter, { TSearchFilterProps } from "./SearchFilter"
import Select from "../../gui/Select/Select"
import LogoutIcon from "../../gui/Icons/LogoutIcon"
import Measure from "../../gui/Measure/Measure"

export type TToolbarProps = TSearchFilterProps & {
    children?:React.ReactNode
    options?:TMenuRow<any>[]
    showAll?:boolean
    itemRenderer?:TMenuItemRenderer<any>
}
export default function Toolbar(props:TToolbarProps){
    const {children,options,showAll,...searchProps} = props
    const [overflow,setOverflow] = useState<boolean>(false)
    
    const {query,setQuery} = usePath()
    const {showDisposed} = PortUtils.getFilter(query)
    const onLogout = () => {
        PortAccount.i.logout()
    }
    const MenuOptions : TMenuRow<any>[] = [...(options||[]), {id:"logout",text:"Logout",icon:<LogoutIcon/>,onClick:onLogout}]
    if (props.showAll) MenuOptions.push({id:"all",text:"All"})
    const itemRenderer = props.itemRenderer ? props.itemRenderer : (option:TMenuRow<any>) : React.ReactNode => {
        if (Select.id(option)=="all") return <Checkbox value={showDisposed} onUpdate={onAll}>Show Disposed</Checkbox>
        else return <MenuRow option={option}/>
    }
    const menuButton = <MenuButton menuProps={{options:MenuOptions,itemRenderer:itemRenderer}} className="icon"><Dot3Icon/></MenuButton>
    const onAll = (e:UpdateEvent<boolean>) => setQuery({show:e.value ? "1" : null})
    const overflowContent = overflow ? <div className="overflow-content flex middle gap-8"><AccountFilter className="flex1"/>{menuButton}</div> : null
    return <Measure id="toolbar" contentClass="toolbar flex middle gap-8" onMeasure={setOverflow} overflowContent={overflowContent}>
        <AccountFilter/>
        <SearchFilter {...searchProps}/>
        {children}
        {menuButton}
    </Measure>

}